import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/Firebase";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import FirebaseApp from "../config/Firebase";

export default function Cart() {
  const [cartProducts, setCartProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Get the user's phone from localStorage (assumed to be stored on login)
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const phone = user.phone;

  useEffect(() => {
    const fetchCart = async () => {
      if (!phone) {
        setLoading(false);
        return;
      }
      try {
        // Get the user's cart document by phone number from Firestore
        const cartDocRef = doc(db, "Cart", phone);
        const cartDocSnap = await getDoc(cartDocRef);
        if (cartDocSnap.exists()) {
          const cartData = cartDocSnap.data();
          const productsInCart = cartData.products || [];
          // Fetch each product's detailed information from the Products collection
          const detailedProducts = await Promise.all(
            productsInCart.map(async (item) => {
              // Change "Products" to your actual collection name if different
              const productDocRef = doc(db, "Products", item.ProductID);
              const productDocSnap = await getDoc(productDocRef);
              let productData = productDocSnap.exists() ? productDocSnap.data() : {};

              // If the stored image URL is not complete, attempt to fetch a download URL.
              // Otherwise, use the provided URL directly.
              if (productData.ImageUrl1 && !productData.ImageUrl1.startsWith("http")) {
                try {
                  const storage = getStorage(FirebaseApp);
                  const imageRef = ref(storage, productData.ImageUrl1);
                  const url = await getDownloadURL(imageRef);
                  productData.ImageUrl1 = url;
                } catch (error) {
                  console.error("Error fetching image URL from storage:", error);
                }
              }

              return {
                ...item,
                productDetails: productData,
              };
            })
          );
          setCartProducts(detailedProducts);
        }
      } catch (err) {
        console.error("Error fetching cart data:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCart();
  }, [phone]);

  // Handler to navigate to the product details page
  const handleProductClick = (product) => {
    navigate("/product-details", { state: product });
  };

  return (
    <>
      <Header />
      <h1>Cart</h1>
      <Footer />
    </>
  );
}
